<template>
  <div style="background-color: white">
    <div class="lightbox">
      <h1>List Mode</h1>
      <p class="my-3">&nbsp;</p>

      <form
        action="/apiExhibitors/ExportExcel/"
        method="post"
        enctype="multipart/form-data"
      >
        <input type="hidden" name="RegNo" :value="`${RegNo}`" />
        <input type="hidden" name="CSRF" :value="`${CSRF_Token}`" />
        <button class="btnStyle mr-2" type="submit">Export Excel</button>
        <a href="#" @click="toUpgradeGetCard" class="btnStyle AddRegLink"
          >Card Mode</a
        >
      </form>
      <p class="my-3">&nbsp;</p>

      <table class="table">
        <thead class="thead-dark text-center">
          <tr>
            <th scope="col">No.</th>
            <th scope="col">Buyer Name</th>
            <th scope="col">Company</th>
            <th scope="col">Country</th>
            <th scope="col">Mobile</th>
            <th scope="col">Email</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center"
            v-for="(item, key) in buyersCard"
            :key="item.No"
          >
            <th scope="row" class="text-center">{{ item.No }}</th>
            <td>{{ item.BuyerName }}</td>
            <td>{{ item.BuyerCompany }}</td>
            <td>{{ item.BuyerCountry }}</td>
            <td>{{ item.BuyerMobile }}</td>
            <td>{{ item.BuyerEmail }}</td>
            <td>{{ item.CreateTime }}</td>
          </tr>
        </tbody>
      </table>

      <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
        <nav>
          <ul class="pagination">
            <li
              v-if="totaltenPageNum > 1"
              class="page-item"
              :class="{ disabled: tenPageNum == 0 }"
            >
              <a
                class="page-link"
                href="#"
                title="Last ten pages"
                aria-label="Previous"
                @click="returntenPage()"
              >
                <span aria-hidden="true"
                  ><i class="fas fa-angle-double-left"></i
                ></span>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage == 1 }">
              <a
                class="page-link"
                href="#"
                title="Last page"
                aria-label="Previous"
                @click="lastPage()"
              >
                <span aria-hidden="true">
                  <i class="fas fa-angle-left"></i>
                </span>
              </a>
            </li>
            <li
              class="page-item"
              v-for="page in showpage"
              :key="page"
              :class="{ active: currentPage == page }"
            >
              <a class="page-link" href="#" @click="getPage(page)">{{
                page
              }}</a>
            </li>

            <li
              class="page-item"
              :class="{ disabled: currentPage == totalPage }"
            >
              <a
                class="page-link"
                href="#"
                title="Next page"
                aria-label="Next"
                @click="nextPage()"
              >
                <span aria-hidden="true"
                  ><i class="fas fa-angle-right"></i
                ></span>
              </a>
            </li>
            <li
              v-if="totaltenPageNum > 1"
              class="page-item"
              :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
            >
              <a
                class="page-link"
                href="#"
                title="Next ten pages"
                aria-label="Next"
                @click="nexttenPage()"
              >
                <span aria-hidden="true"
                  ><i class="fas fa-angle-double-right"></i
                ></span>
              </a>
            </li>
          </ul>
          <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      CSRF_Token: "",
      RegNo: "",
      PageSize: 1,
      buyersCard: [], //ok
      totalPage: "",
      totalNo: "",
      currentPage: 1,
      buyerRawData: [], //rawData
      totaltenPageNum: "", //共幾筆十頁

      showpage: [],
      tenPageNum: "",
    };
  },
  methods: {
    toUpgradeGetList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeGetList?no=${vm.RegNo}`;
    },

    toUpgradeGetCard() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeGetCard?no=${vm.RegNo}`;
    },

    getPage(page) {
      const vm = this;
      vm.currentPage = page;
      vm.newPageApi();
    },

    nextPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) + 1;
      vm.newPageApi();
    },

    lastPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) - 1;
      vm.newPageApi();
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.inviteRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.inviteRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    mainPageApi() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/buyers/${vm.RegNo}?Page=${vm.currentPage}`
        )
        .then((response) => {
          if (response.data.pagetotal > 0) {
            vm.buyersCard = response.data.Data;
            vm.totalPage = response.data.pagetotal;
            vm.totalNo = response.data.datatotal;

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.buyerRawData.push([]);
              }

              const page = parseInt(i / 10); //parseInt整數公式
              vm.buyerRawData[page].push(i + 1);
            }

            //totaltenPageNum 取得共有幾筆十頁
            vm.totaltenPageNum = vm.buyerRawData.length;

            //從取得的筆數後，tenNum 計算出現第幾個十頁數

            let anaNowPage = vm.currentPage - 1; //判定第幾頁(十位)，頁數減一避免進位

            vm.tenPageNum = parseInt(anaNowPage / 10);
            vm.showpage = vm.buyerRawData[vm.tenPageNum];
          }
        });
    },

    newPageApi() {
      const vm = this;

      let url = `/apiExhibitors/buyers/${vm.RegNo}?Page=${vm.currentPage}`;

      axios.get(url).then(function (response) {
        vm.buyersCard = response.data.Data;

        let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

        vm.tenPageNum = parseInt(anaNowPage / 10);
        vm.showpage = vm.inviteRawData[vm.tenPageNum];
      });
    },

    ExportExcel() {
      const vm = this;

      let url = `/apiExhibitors/ExportExcel/`;
      let info = {
        RegNo: vm.RegNo,
        CSRF: vm.CSRF_Token,
      };
      axios.post(url, info).then(function (response) {});
    },
  },

  created() {
    const vm = this;

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    vm.mainPageApi();
  },
};
</script>

<style lang="scss">
a:hover {
  color: #ffffff;
  text-decoration: none;
}

body {
  background-color: rgb(255, 255, 255);
}
</style>
